export default {
  props: {
    required: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    getForm() {
      return this.copyOfForm;
    }
  }
};
